import useStateStore from 'services/store';
import './nice-watch.scss';

const niceWatch = [
  {
    id: 'left',
    name: 'YES, ON MY LEFT',
  },
  {
    id: 'right',
    name: 'YES, ON MY RIGHT',
  },
  {
    id: 'no',
    name: 'NO, THANKS',
  },
];

const NiceWatch = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('nice-watch', id);
  };
  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">HEY! NICE WATCH!</div>
        <div className="confirm">
          Do you want us to add some space to your cuff?
        </div>
      </div>
      <div className="text-options nice-watch">
        {niceWatch.map((watch) => (
          <div
            onClick={() => handleChangeSteps(watch.id)}
            key={watch.id}
            className={`text-option ${
              steps['nice-watch'] === watch.id ? 'active' : ''
            }`}
          >
            {watch.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NiceWatch;
